import React from "react";
import { Link } from "react-router-dom";
import { Money, Time, Parcel, Layananimg2, Lawfirm, Legalbisnis, Agro, Aboutusimg } from "../assets/images";
import { FaPeopleGroup } from "react-icons/fa6";

function Layananlawfirm() {
    return (
        <div className="md:pt-12 pt-14">


            {/* Alur Pendaftaran Merek */}
            <h1 data-aos="fade-down" className="text-3xl bg-white text-primary font-bold text-center pt-10 md:px-32 px-5">
                Perjalanan Proses Merek Kemenkumham
            </h1>

            {/* Alur Versi Dekstop & Tab */}
            <div className="md:w-10/12 w-11/12 md:flex-row md:flex hidden my-10 mx-auto justify-center items-center">

                <div data-aos="fade-left" className="flex-1 md:order-1 flex justify-center">
                    <ol className="relative ml-24 text-primary border-l-4 border-secondary mb-2 -pb-3 ">
                        <li className="mb-10 ml-6">
                            <span className="absolute flex items-center justify-center w-8 h-8 bg-white rounded-full -left-4 ring-4 ring-secondary ">
                                <p className="text-primary font-bold">1</p>
                            </span>
                            <h3 className="font-medium leading-tight">Pemeriksaan Formalitas</h3>
                            <p className="text-sm">7 Hari Kerja</p>
                        </li>
                        <li className="mb-10 ml-6">
                            <span className="absolute flex items-center justify-center w-8 h-8 bg-white rounded-full -left-4 ring-4 ring-secondary ">
                                <p className="text-primary font-bold">2</p>
                            </span>
                            <h3 className="font-medium leading-tight">Untuk Dipublikasi</h3>
                            <p className="text-sm">7 Hari Kerja</p>
                        </li>
                        <li className="ml-6">
                            <span className="absolute flex items-center justify-center w-8 h-8 bg-white rounded-full bottom-1 -left-4 ring-4 ring-secondary ">
                                <p className="text-primary font-bold">3</p>
                            </span>
                            <h3 className="font-medium leading-tight">BRM Masa Pengumuman</h3>
                            <p className="text-sm">90 Hari Kerja</p>
                        </li>
                    </ol>
                </div>

                <div data-aos="fade-up" className="flex-1 md:order-2 md:mt-0 mt-11">
                    <ol className="relative ml-24 text-primary border-l-4 border-secondary mb-2 -pb-3 ">
                        <li className="mb-10 ml-6">
                            <span className="absolute flex items-center justify-center w-8 h-8 bg-white rounded-full -left-4 ring-4 ring-secondary ">
                                <p className="text-primary font-bold">4</p>
                            </span>
                            <h3 className="font-medium leading-tight">BRM Selesai Masa Pengumuman</h3>
                            <p className="text-sm">90 Hari Kerja</p>
                        </li>
                        <li className="mb-10 ml-6">
                            <span className="absolute flex items-center justify-center w-8 h-8 bg-white rounded-full -left-4 ring-4 ring-secondary ">
                                <p className="text-primary font-bold">5</p>
                            </span>
                            <h3 className="font-medium leading-tight">Pelayanan Teknis</h3>
                            <p className="text-sm">90 Hari Kerja</p>
                        </li>
                        <li className="mb-10 ml-6">
                            <span className="absolute flex items-center justify-center w-8 h-8 bg-white rounded-full -left-4 ring-4 ring-secondary ">
                                <p className="text-primary font-bold">6</p>
                            </span>
                            <h3 className="font-medium leading-tight">Pemeriksaan Subtantif (DISTDOC 1)</h3>
                            <p className="text-sm">90 Hari Kerja</p>
                        </li>
                        <li className="ml-6">
                            <span className="absolute flex items-center justify-center w-8 h-8 bg-white rounded-full bottom-1 -left-4 ring-4 ring-secondary ">
                                <p className="text-primary font-bold">7</p>
                            </span>
                            <h3 className="font-medium leading-tight">Pemeriksaan Oleh Kasubdit</h3>
                            <p className="text-sm">90 Hari Kerja</p>
                        </li>
                    </ol>
                </div>

                <div data-aos="fade-left" className="flex-1 md:order-3 md:mt-0 mt-11">
                    <ol className="relative ml-24 text-primary border-l-4 border-secondary mb-2 -pb-3 ">
                        <li className="mb-10 ml-6">
                            <span className="absolute flex items-center justify-center w-8 h-8 bg-white rounded-full -left-4 ring-4 ring-secondary ">
                                <p className="text-primary font-bold">8</p>
                            </span>
                            <h3 className="font-medium leading-tight">Persetujuan Direktur Untuk Diberi</h3>
                            <p className="text-sm">30 Hari Kerja</p>
                        </li><li className="mb-10 ml-6">
                            <span className="absolute flex items-center justify-center w-8 h-8 bg-white rounded-full -left-4 ring-4 ring-secondary ">
                                <p className="text-primary font-bold">9</p>
                            </span>
                            <h3 className="font-medium leading-tight">Untuk Di Daftar</h3>
                            <p className="text-sm">30 Hari Kerja</p>
                        </li>
                        <li className="ml-6">
                            <span className="absolute flex items-center justify-center w-8 h-8 bg-white rounded-full bottom-1 -left-4 ring-4 ring-secondary ">
                                <p className="text-primary font-bold">10</p>
                            </span>
                            <h3 className="font-medium leading-tight">Di Daftar</h3>
                            <p className="text-sm">30 Hari Kerja</p>
                        </li>
                    </ol>
                </div>

            </div>

            {/* Alur Versi Mobile */}
            <div className="md:w-10/12 w-11/12 flex-row flex md:hidden mt-10 mx-auto justify-center items-center mb-10">

                <div data-aos="flip-right" className="flex-1 md:order-1 flex justify-center">
                    <ol className="relative ml-3 text-primary border-l-4 border-secondary mb-2 -pb-3 ">
                        <li className="mb-10 ml-6">
                            <span className="absolute flex items-center justify-center w-8 h-8 bg-white rounded-full -left-4 ring-4 ring-secondary ">
                                <p className="text-primary font-bold">1</p>
                            </span>
                            <h3 className="font-medium leading-tight">Pemeriksaan Formalitas</h3>
                            <p className="text-sm">7 Hari Kerja</p>
                        </li>
                        <li className="mb-10 ml-6">
                            <span className="absolute flex items-center justify-center w-8 h-8 bg-white rounded-full -left-4 ring-4 ring-secondary ">
                                <p className="text-primary font-bold">2</p>
                            </span>
                            <h3 className="font-medium leading-tight">Untuk Dipublikasi</h3>
                            <p className="text-sm">7 Hari Kerja</p>
                        </li>
                        <li className="mb-10 ml-6">
                            <span className="absolute flex items-center justify-center w-8 h-8 bg-white rounded-full -left-4 ring-4 ring-secondary ">
                                <p className="text-primary font-bold">3</p>
                            </span>
                            <h3 className="font-medium leading-tight">BRM Masa Pengumuman</h3>
                            <p className="text-sm">90 Hari Kerjaa</p>
                        </li>
                        <li className="mb-10 ml-6">
                            <span className="absolute flex items-center justify-center w-8 h-8 bg-white rounded-full -left-4 ring-4 ring-secondary ">
                                <p className="text-primary font-bold">4</p>
                            </span>
                            <h3 className="font-medium leading-tight">BRM Selesai Masa Pengumuman</h3>
                            <p className="text-sm">90 Hari Kerja</p>
                        </li>
                        <li className="ml-6">
                            <span className="absolute flex items-center justify-center w-8 h-8 bg-white rounded-full bottom-1 -left-4 ring-4 ring-secondary ">
                                <p className="text-primary font-bold">5</p>
                            </span>
                            <h3 className="font-medium leading-tight">Pelayanan Teknis</h3>
                            <p className="text-sm">90 Hari Kerja</p>
                        </li>
                    </ol>
                </div>

                <div data-aos="flip-left" className="flex-1 md:order-2 md:mt-0 mt-0 ">
                    <ol className="relative ml-3 text-primary border-l-4 border-secondary mb-2 -pb-3 ">
                        <li className="mb-10 ml-6">
                            <span className="absolute flex items-center justify-center w-8 h-8 bg-white rounded-full -left-4 ring-4 ring-secondary ">
                                <p className="text-primary font-bold">6</p>
                            </span>
                            <h3 className="font-medium leading-tight">Pemeriksaan Subtantif <br /> (DISTDOC 1)</h3>
                            <p className="text-sm">90 Hari Kerja</p>
                        </li>
                        <li className="mb-10 ml-6">
                            <span className="absolute flex items-center justify-center w-8 h-8 bg-white rounded-full -left-4 ring-4 ring-secondary ">
                                <p className="text-primary font-bold">7</p>
                            </span>
                            <h3 className="font-medium leading-tight">Pemeriksaan Oleh Kasubdit</h3>
                            <p className="text-sm">90 Hari Kerja</p>
                        </li>
                        <li className="mb-10 ml-6">
                            <span className="absolute flex items-center justify-center w-8 h-8 bg-white rounded-full -left-4 ring-4 ring-secondary ">
                                <p className="text-primary font-bold">8</p>
                            </span>
                            <h3 className="font-medium leading-tight">Persetujuan Direktur Untuk Diberi</h3>
                            <p className="text-sm">30 Hari Kerja</p>
                        </li>
                        <li className="mb-10 ml-6">
                            <span className="absolute flex items-center justify-center w-8 h-8 bg-white rounded-full -left-4 ring-4 ring-secondary ">
                                <p className="text-primary font-bold">9</p>
                            </span>
                            <h3 className="font-medium leading-tight">Untuk Di Daftar</h3>
                            <p className="text-sm">30 Hari Kerja</p>
                        </li>
                        <li className="ml-6">
                            <span className="absolute flex items-center justify-center w-8 h-8 bg-white rounded-full bottom-1 -left-4 ring-4 ring-secondary ">
                                <p className="text-primary font-bold">10</p>
                            </span>
                            <h3 className="font-medium leading-tight">Di Daftar</h3>
                            <p className="text-sm">30 Hari Kerja</p>
                        </li>
                    </ol>
                </div>

            </div>


            {/* Persyaratan */}
            <div>
                <div
                    className="bg-primary md:w-10/12 w-11/12 md:flex-row flex-col my-16 p-5 rounded-lg mx-auto self-center object-center flex justify-center items-center"
                    style={{ boxShadow: "6px 6px 0 rgba(10,10,10,.3)" }} >
                    <div data-aos="fade-right" className="flex-1 md:order-1 md:mt-0 mt-11 px-10 md:border-r-2 md:border-r-secondary md:border-b-0 border-b-2 border-b-secondary ">
                        <h2 className="text-2xl font-bold text-white tracking-wide text-center ">
                            Persyaratan Pendaftaran Merek Atas Nama Pribadi
                        </h2>
                        <h3 className="text-lg text-white tracking-wide mt-8">
                            1. KTP <br />
                            2. NPWP ( tidak diwajibkan ) <br />
                            3. Logo & Merek <br />
                            4. Alamat Email Aktif <br /> <br />
                        </h3>
                    </div>
                    <div data-aos="fade-right" className="flex-1 md:order-1 md:mt-0 mt-11 px-10 ">
                        <h2 className="text-2xl font-bold text-white tracking-wide text-center ">
                            Persyaratan Pendaftaran Merek Atas Nama Perusahaan
                        </h2>
                        <h3 className="text-lg text-white tracking-wide mt-8">
                            1. KTP Direktur <br />
                            2. NPWP Perusahaan ( WAJIB ) <br />
                            3. AKta Perusahaan / Akta Perubahan Terbaru <br />
                            4. Logo & Merek <br />
                            5. Alamat Email Aktif <br />
                        </h3>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Layananlawfirm;
